module.exports = __webpack_public_path__ + "images/hero/state-heroes/wyoming.jpg";